import { Component, Input } from '@angular/core';
import { TimelineNoteModalService } from 'src/app/core/services/modal-services/timeline-note-modal.service';
import { TimelineDisplay } from 'src/app/core/enums/timeline-display-enum';
import { TimelineNoteListComponent } from '../../list-views/timeline-note-list/timeline-note-list.component';
import { TimeLineType } from 'src/app/core/enums/timeline-type-enum';

@Component({
  selector: 'app-timeline-modal',
  templateUrl: './timeline-modal.component.html',
  styleUrls: ['./timeline-modal.component.scss'],
  providers: [TimelineNoteModalService]
})
export class TimelineModalComponent extends TimelineNoteListComponent {

  enumTimeLineDisplay = TimelineDisplay;
  enumTimeLineType = TimeLineType;
  isNotListLoaded = true;

  @Input() public display: TimelineDisplay = TimelineDisplay.Default;
  @Input() public maxHeight: string = "90px";
  @Input() public displayDropdownButton: boolean = true;

  override ngOnInit(): void {
    this.timeLineListService.ownerId = this.timelineOwnerId;

    if (this.timelineType != undefined) {
      this.timeLineListService.types = [this.timelineType];
    }

    this.listItemsObservable = this.timeLineListService.resultItems$;
    this.total = this.timeLineListService.total$;
    this.isLoading = this.timeLineListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.isLoadingVal = true;
      } else {
        this.isLoadingVal = false;
      }
    });
    this.unsubscribe.push(subscr);

    if (this.createdByUser) {
      this.timeLineListService.createdById = this.authMyFileService.currentUserContextValue?.id;
    }

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      if (this.listItems.length > 0) {
        this.isNotListLoaded = false;
      };
    });
    this.unsubscribe.push(subscr2);

    //used to start the search since their is no call for it in the HTML like all other lists which have pagination. 
    this.timeLineListService.refresh();
  }

  loadMore(service: any) {
    if (service.pageSize < service.totalRecords) {
      if ((service.totalRecords - service.pageSize) < 10) {
        service.pageSize = service.pageSize + (service.totalRecords - service.pageSize);
      } else {
        service.pageSize = service.pageSize + 10;
      }
    }
  }

  updateCharCount(showFullText: boolean | undefined): number | undefined {
    if (showFullText === true) {
      return 25;
    }
    return undefined
  }

  showText(data: any) {
    if (data.showOverFlowText == true) {
      data.showOverFlowText = false;
    } else {
      data.showOverFlowText = true;
    }
  }

}
